module.exports = __webpack_public_path__ + "img/douyin.da2c6fd5.png";